// src/api/lectureHorsInterface.ts — SCE Issues
// Lire un gros classeur dans un worker (workers/registreNcs.worker) : le
// registre qualité, la liste des composants NVS. L'interface ne fige jamais.
// Sans worker (bancs d'essai), la lecture se fait directement.

import { lireRegistreNcs, type LigneRegistre } from '@/utils/registreNcs'
import { lireListeComposants, type Composant } from '@/utils/composants'
import type { DemandeLecture, ReponseRegistre } from '@/workers/registreNcs.worker'

async function lireDansWorker(demande: DemandeLecture): Promise<ReponseRegistre> {
  const worker = new Worker(new URL('../workers/registreNcs.worker.ts', import.meta.url), { type: 'module' })
  try {
    const reponse = await new Promise<ReponseRegistre>((resoudre, rejeter) => {
      worker.onmessage = (e: MessageEvent<ReponseRegistre>) => resoudre(e.data)
      worker.onerror = (e) => rejeter(new Error(e.message || 'Lecture du classeur impossible'))
      worker.postMessage(demande, [demande.octets])
    })
    if ('erreur' in reponse) throw new Error(reponse.erreur)
    return reponse
  } finally {
    worker.terminate()
  }
}

export async function lireRegistreHorsInterface(octets: ArrayBuffer): Promise<LigneRegistre[]> {
  if (typeof Worker === 'undefined') return lireRegistreNcs(octets)
  const r = await lireDansWorker({ genre: 'registre', octets })
  return 'lignes' in r ? r.lignes : []
}

export async function lireComposantsHorsInterface(octets: ArrayBuffer): Promise<Composant[]> {
  if (typeof Worker === 'undefined') return lireListeComposants(octets)
  const r = await lireDansWorker({ genre: 'composants', octets })
  return 'composants' in r ? r.composants : []
}
